import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export async function getMe() {
  const { data } = await api.get("/auth/me");
  return data;
}

export async function getAdminUsers() {
  const { data } = await api.get("/admin/users");
  return data;
}

export async function logout() {
  await api.post("/auth/logout");
}

export async function startDebate(category, difficulty, customTopic) {
  const { data } = await api.post("/debate/start", {
    category: category || null,
    difficulty: difficulty || null,
    custom_topic: customTopic || null,
  });
  return data;
}

export async function getSeoDebate(slug) {
  const { data } = await api.get(`/seo/debates/${slug}`);
  return data;
}

export async function startSeoDebate(slug, difficulty = "pesada") {
  const { data } = await api.post("/debate/start", {
    seo_slug: slug,
    difficulty: difficulty || null,
  });
  return data;
}

export async function submitRound(debateId, argument) {
  const { data } = await api.post("/debate/round", { debate_id: debateId, argument });
  return data;
}

export async function getDebate(debateId) {
  const { data } = await api.get(`/debate/${debateId}`);
  return data;
}

const GUEST_TOKEN_KEY = "convenceme_guest_token";

export function saveGuestToken(token) {
  try {
    sessionStorage.setItem(GUEST_TOKEN_KEY, token);
  } catch (_e) {}
}

export function getGuestToken() {
  try {
    return sessionStorage.getItem(GUEST_TOKEN_KEY);
  } catch (_e) {
    return null;
  }
}

export async function startDemoDebate(seoSlug = null) {
  const body = seoSlug ? { seo_slug: seoSlug } : undefined;
  const { data } = await api.post("/debate/demo/start", body);
  if (data.guest_token) saveGuestToken(data.guest_token);
  return data;
}

export async function submitDemoRound(debateId, argument) {
  const guest_token = getGuestToken();
  const { data } = await api.post("/debate/demo/round", {
    debate_id: debateId,
    argument,
    guest_token,
  });
  return data;
}

export async function getDemoDebate(debateId) {
  const guest_token = getGuestToken();
  const { data } = await api.get(`/debate/demo/${debateId}`, {
    params: { guest_token },
  });
  return data;
}

export async function getLeaderboard() {
  const { data } = await api.get("/leaderboard");
  return data;
}

export async function getCategories() {
  const { data } = await api.get("/categories");
  return data;
}

export async function getDifficulties() {
  const { data } = await api.get("/difficulties");
  return data;
}

export async function getUsage() {
  const { data } = await api.get("/usage/today");
  return data;
}

export async function getProfileStats() {
  const { data } = await api.get("/profile/stats");
  return data;
}

export async function mockUpgrade() {
  const { data } = await api.post("/billing/mock-upgrade");
  return data;
}

export async function mockCancel() {
  const { data } = await api.post("/billing/mock-cancel");
  return data;
}

export async function getDailyToday() {
  const { data } = await api.get("/daily/today");
  return data;
}

export async function getDailyPublic() {
  const { data } = await api.get("/daily/public");
  return data;
}

export async function getRebecaHome() {
  const { data } = await api.get("/rebeca/home");
  return data;
}

export async function getRebecaGuest() {
  const { data } = await api.get("/rebeca/guest");
  return data;
}

export async function startDailyDebate() {
  const { data } = await api.post("/debate/daily/start");
  return data;
}

export async function getDailyLeaderboard() {
  const { data } = await api.get("/leaderboard/daily");
  return data;
}

export async function getWeeklyLeaderboard() {
  const { data } = await api.get("/leaderboard/weekly");
  return data;
}

export async function getLeagueWeekly(tier = null) {
  const { data } = await api.get("/league/weekly", {
    params: tier ? { tier } : {},
  });
  return data;
}

export async function getCategoryLeaderboard(categoryId) {
  const { data } = await api.get(`/leaderboard/category/${categoryId}`);
  return data;
}

export async function setFavoriteTitle(titleId) {
  const { data } = await api.post("/profile/favorite-title", { title_id: titleId });
  return data;
}

export async function createChallenge(debateId) {
  const { data } = await api.post("/challenge/create", { debate_id: debateId });
  return data;
}

export async function getChallenge(challengeId) {
  const { data } = await api.get(`/challenge/${challengeId}`);
  return data;
}

export async function getTodayStats() {
  const { data } = await api.get("/stats/today");
  return data;
}

export async function createMPPreference() {
  const { data } = await api.post("/billing/create-preference");
  return data;
}

export async function verifyPayment(paymentId) {
  const { data } = await api.get(`/billing/verify-payment?payment_id=${paymentId}`);
  return data;
}

export async function generateRandomTopic() {
  const { data } = await api.get("/debate/generate-topic");
  return data;
}

export async function startChallengeDebate(challengeId, difficulty) {
  const { data } = await api.post("/debate/start", {
    challenge_id: challengeId,
    difficulty: difficulty || null,
  });
  return data;
}

export async function getNotifications() {
  const { data } = await api.get("/notifications");
  return data;
}

export async function markNotificationRead(notificationId) {
  await api.post(`/notifications/${notificationId}/read`);
}

export async function markAllNotificationsRead() {
  await api.post("/notifications/read-all");
}
